import axios from "../../axios";
import { parseContentDispositionFilename } from "../../../utils/http";

const BASE_URL = "/organization-questionnaires";

const api = {
  // CATEGORY 11
  getUseOfSoldProductsItems(params, accessToken) {
    const config = {
      params: params.queryParams,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`${BASE_URL}/${params.questionnaireId}/use-of-sold-products/items`, config)
      .then(({ data }) => data);
  },

  addUseOfSoldProductsItems({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`${BASE_URL}/${questionnaireId}/use-of-sold-products/items`, data, headers)
      .then(({ data }) => data);
  },

  updateUseOfSoldProductsItem({ questionnaireId, recordId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`${BASE_URL}/${questionnaireId}/use-of-sold-products/items/${recordId}`, data, headers)
      .then(({ data }) => data);
  },

  deleteUseOfSoldProductsItem({ questionnaireId, recordId }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(`${BASE_URL}/${questionnaireId}/use-of-sold-products/items/${recordId}`, headers)
      .then(({ data }) => data);
  },

  importUseOfSoldProducts({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`${BASE_URL}/${questionnaireId}/use-of-sold-products/import`, data, headers).then(({data}) => data);
  },

  updateUseOfSoldProducts({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.patch(`${BASE_URL}/${questionnaireId}/use-of-sold-products`, data, headers).then(({data}) => data);
  },

  getUseOfSoldProductsTemplate(questionnaireId, accessToken) {
    const config = {
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(
      `${BASE_URL}/${questionnaireId}/use-of-sold-products/template`, config
    ).then(({ data, headers }) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      const defaultFileName = parseContentDispositionFilename(
        headers["content-disposition"], "Scope3_Category11_template.xlsx");
      link.href = url;
      link.setAttribute("download", defaultFileName);
      document.body.appendChild(link);
      link.click();
      return true;
    });
  }
};

export default api;
